<template>
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle opacity="0.5" cx="9.99935" cy="10" r="8.33333" stroke="currentColor" stroke-width="1.5"/>
  <path d="M12.0827 7.91667L7.91602 12.0833M7.916 7.91666L12.0826 12.0833" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>

</template>